import {IComponentOptions, IRootElementService} from "angular";
import template from "./StockScreenerViewComponent.html";
import {LanguageService} from "../../translation/service/LanguageService";
import {Observable } from "rxjs";
import {TranslationsLanguage} from "../../translation/config/TranslationsLanguage";
import {ThemingStore} from "../../theming/store/ThemingStore";
import {ThemeType} from "../../types/UserConfig";
import {GTMConversionEventService} from "../../analytics/services/GTMConversionEventService";

export const StockScreenerView = "tfStockScreenerView";

export function stockScreenerView(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: StockScreenerViewComponentController
    };
}

export class StockScreenerViewComponentController {

    /** @ngInject */
    public constructor(private readonly $element: IRootElementService,
                       readonly themingStore: ThemingStore,
                       readonly languageService: LanguageService,
                       private readonly gtmConversionEventService: GTMConversionEventService) {

        const language$ = this.languageService
                              .current()
                              .take(1)
                              .map(StockScreenerViewComponentController.mapLanguage);

        const theme$ = this.themingStore
                           .currentTheme
                           .take(1)
                           .map(StockScreenerViewComponentController.mapTheme);

        Observable.combineLatest(language$, theme$)
                  .subscribe(([language, theme]) => this.loadWidget(language, theme));

        this.gtmConversionEventService.sendPageView(
            {
                path: "stock-screener",
                hostUrl: window.location.host,
                title: "Stock Screener"
            }
        );
    }

    private static mapLanguage(language: TranslationsLanguage): string {
        switch (language) {
            case TranslationsLanguage.Chinese:
                return "zh_CN";
            case TranslationsLanguage.English:
                return "en";
        }
    }

    private static mapTheme(theme: ThemeType): string {
        switch (theme) {
            case "dark":
                return "dark";
            case "light":
                return "light";
        }
    }

    private loadWidget(language: string, theme: string) {
        const root = this.$element[0];
        const container = root.querySelector(".tradingview-widget-container")!;
        const script = document.createElement("script");
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-screener.js";
        script.async = true;

        script.textContent = this.widgetSettings(language, theme);
        container.appendChild(script);
    }

    private widgetSettings(language: string, theme: string): string {

        // language=json
        return `{
            "width": "100%",
                "height": "100%",
                "defaultColumn": "overview",
                "defaultScreen": "most_capitalized",
                "market": "australia",
                "showToolbar": true,
                "colorTheme": "${theme}",
                "locale": "${language}",
                "largeChartUrl": "${this.chartingUrl()}"
        }`;
    }

    private chartingUrl(): string {
        const host = window.location.host;
        return `${host}/tradefloor/#!/trading-view/charting`;
    }
}
